import styled from "styled-components";
import media from "../../static/style/media";
import add from "../../image/add.png";
import modify from "../../image/modify.png";
import del from "../../image/delete.png";
import AddDeviceModal from "../Modal/AddDeviceModal";
import { useState } from "react";
import DeleteDeviceModal from "../Modal/DeleteDeviceModal";
import ModifyDeviceModal from "./../Modal/ModifyDeviceModal";
import AddCategoryModal from "../Modal/AddCategoryModal";
import DeleteCategoryModal from "../Modal/DeleteCategoryModal";
import { useTranslation } from "react-i18next";

export default function DeviceSideNav() {
  const [activeModal, setActiveModal] = useState(null);

  function openModal(modalName) {
    setActiveModal(modalName);
  }

  function closeModal() {
    setActiveModal(null);
  }

  const { t } = useTranslation();

  return (
    <Container>
      <NavHeader>{t(`category`)}</NavHeader>
      <ActionButton onClick={() => openModal("addCategory")} color="#e3f2fd">
        <AddImg />
        {t(`add category`)}
      </ActionButton>
      <ActionButton onClick={() => openModal("deleteCategory")} color="#ffebee">
        <DeleteImg />
        {t(`delete category`)}
      </ActionButton>
      <NavHeader>{t(`device`)}</NavHeader>
      <ActionButton onClick={() => openModal("addDevice")} color="#e3f2fd">
        <AddImg />
        {t(`add device`)}
      </ActionButton>
      <ActionButton onClick={() => openModal("deleteDevice")} color="#ffebee">
        <DeleteImg />
        {t(`delete device`)}
      </ActionButton>
      <ActionButton onClick={() => openModal("modifyDevice")} color="#f5f5f5">
        <ModifyImg />
        {t(`modify device`)}
      </ActionButton>
      <AddDeviceModal
        isOpen={activeModal === "addDevice"}
        isClose={closeModal}
      />
      <DeleteDeviceModal
        isOpen={activeModal === "deleteDevice"}
        isClose={closeModal}
      />
      <ModifyDeviceModal
        isOpen={activeModal === "modifyDevice"}
        isClose={closeModal}
      />
      <AddCategoryModal
        isOpen={activeModal === "addCategory"}
        isClose={closeModal}
      />
      <DeleteCategoryModal
        isOpen={activeModal === "deleteCategory"}
        isClose={closeModal}
      />
    </Container>
  );
}

// Styled components
const Container = styled.div`
  width: 210px;
  padding: 20px;
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  ${media.small`
    grid-template-columns: repeat(5, 18vw);
    padding: 15px;
  `};
`;

const NavHeader = styled.div`
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  padding: 10px;
  background-color: #f0f4f8;
  border-radius: 8px;
  color: #333;
  margin-bottom: 10px;
  ${media.small`
    display: none;
  `};
`;

const ActionButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 12px;
  background-color: ${(props) => props.color};
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  color: #333;
  transition: all 0.3s ease;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  white-space: pre;

  &:hover {
    background-color: ${(props) => props.color};
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  }

  ${media.small`
    font-size: 12px;
  `};
`;

const AddImg = styled.img.attrs({
  src: `${add}`,
})`
  width: 30px;
  height: 30px;
`;

const DeleteImg = styled.img.attrs({
  src: `${del}`,
})`
  width: 30px;
  height: 30px;
`;

const ModifyImg = styled.img.attrs({
  src: `${modify}`,
})`
  width: 30px;
  height: 30px;
`;

